import { render, staticRenderFns } from "./lockscreen.vue?vue&type=template&id=1f479ea4"
import script from "./lockscreen.vue?vue&type=script&lang=ts"
export * from "./lockscreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports